export default __webpack_public_path__ + "static/media/info.c14c7b9e.png";